/* eslint-disable */

import {
  AD_IMPORT_FETCH_HTML,
  AD_IMPORT_FETCH_HTML_SUCCESS,
  AD_IMPORT_FETCH_HTML_ERROR,
  AD_IMPORT_INSERT,
  AD_IMPORT_INSERT_SUCCESS,
  AD_IMPORT_INSERT_ERROR,
  AD_IMPORT_FETCH_PRESENTATION,
  AD_IMPORT_FETCH_PRESENTATION_SUCCESS,
  AD_IMPORT_FETCH_PRESENTATION_ERROR
} from '../constants/ActionTypes';
import domains from '../containers/Domains';
import { api as apiBuilder } from '../utils/apiBuilder';
const operation = 'import/ad';
const endpoint = apiBuilder.buildApi(operation);

const initialState = {
  loading: false,
  preview: null,
  presentationData: null,
  uploadOptions: {
    //server: `${domains[window.location.hostname]}import/ad`,
    server: endpoint,
    Accept: 'application/json',
    'Content-Type': 'text/plain'
    // uploadRequestHeaders: { 'x-amz-acl': 'public-read' }
  },
  s3Url: 'https://s3.amazonaws.com/alexia-import-ad',
  importId: null,
  htmlUrl: '',
  error: null
};

export default function adimport(state = initialState, action) {
  switch (action.type) {
    case AD_IMPORT_FETCH_HTML:
      return {
        ...state,

        loading: true
      };
    case AD_IMPORT_FETCH_HTML_SUCCESS:
      const preview = action.url
        ? `<iframe src="${action.url}"></iframe>`
        : null;
      return {
        ...state,

        loading: false,
        htmlUrl: action.url,
        preview
      };
    case AD_IMPORT_FETCH_HTML_ERROR:
      return {
        ...state,

        loading: false,
        error: action.error
      };
    case AD_IMPORT_INSERT:
      return {
        ...state,

        loading: true
      };
    case AD_IMPORT_INSERT_SUCCESS:
      return {
        ...state,

        loading: false,
        importId: action.id
      };
    case AD_IMPORT_INSERT_ERROR:
      return {
        ...state,

        loading: false,
        error: action.error
      };
    case AD_IMPORT_FETCH_PRESENTATION:
      return {
        ...state,

        loading: true
      };
    case AD_IMPORT_FETCH_PRESENTATION_SUCCESS:
      return {
        ...state,

        loading: false,
        presentationData: action.data,
        preview
      };
    case AD_IMPORT_FETCH_PRESENTATION_ERROR:
      return {
        ...state,

        loading: false,
        error: action.error
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/ad.import.js